module.exports = __webpack_public_path__ + "static/media/58.f3465e5b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/58.jpg
// module id = 619
// module chunks = 0